import { render, staticRenderFns } from "./GalleryModule.vue?vue&type=template&id=0efd9dfe&scoped=true"
import script from "./GalleryModule.vue?vue&type=script&lang=js"
export * from "./GalleryModule.vue?vue&type=script&lang=js"
import style0 from "./GalleryModule.vue?vue&type=style&index=0&id=0efd9dfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efd9dfe",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/GalleryModule.vue
// module id = 170
// module chunks = 0